// extracted by mini-css-extract-plugin
export default {"lot-estimate":"lot-estimate_lot-estimate__lEwim","estimate-head":"lot-estimate_estimate-head__zwxKg","estimate-amount":"lot-estimate_estimate-amount__y8Vlr"};